import httpCommerce from './httpCommerce'

const EUROCHANGE_COMMERCE_LEGACY_TOKEN = 'eurochange_commerce_token'

export const createSession = () => {
  const siteId = window.commerceSettings?.siteId;

  return httpCommerce.post(`/session/${siteId}`, null, {
    withCredentials: true
  });
}

export const createFromLegacyToken = () => {
  const siteId = window.commerceSettings?.siteId;

  const legacyToken = window.localStorage.getItem(EUROCHANGE_COMMERCE_LEGACY_TOKEN);

  return httpCommerce.post(`/session/${siteId}`, null, {
    withCredentials: true,
    headers: {
      Authorization: `bearer ${legacyToken}`
    }    
  });
}

export const getToken = () => {
  const siteId = window.commerceSettings?.siteId;

  return httpCommerce.get(`/session/${siteId}/token`, {
    withCredentials: true
  });
}

export default {
  createSession,
  createFromLegacyToken,
  getToken
}
